import { action, observable } from 'mobx';
import apiCaller from '../../utils/api-caller';
import moment from 'moment';

class CmsTaskStore {
  cmsUsername = window.localStorage.getItem('adminLoginName')?.replace(/(^['"]|['"]$)/g, '');

  @observable taskTreeData = [];
  @observable taskTreeList = [];
  @observable taskTreeLoading = false;
  @observable expandedTaskTree = [];
  @observable selectedTaskTree = [];

  @observable taskShorts = [];
  @observable task = null;

  @action getTreeTasks() {
    return apiCaller.CmsTasks.getTree().then(resp => {
      if (!resp.isError) {
        this.taskTreeData = resp.data;
        this.generateList(this.taskTreeData);
      } else {
        this.taskTreeLoading = false;
      }
    });
  }

  @action getShorts() {
    return apiCaller.CmsTasks.getShorts().then(resp => {
      if (!resp.isError) {
        this.taskShorts = resp.data;
      } else {
        this.taskShorts = [];
      }
    });
  }

  @action getByTaskId(taskID) {
    return apiCaller.CmsTasks.getById(taskID).then(resp => {
      if (!resp.isError) {
        this.task = resp.data;

        if (this.task) {
          if (this.task.startTime === null || this.task.startTime === '') {
            this.task.startTimeDate = null;
          } else {
            this.task.startTimeDate = moment(`${moment().format('YYYY-MM-DD')} ${this.task.startTime}`);
          }

          if (this.task.endTime === null || this.task.endTime === '') {
            this.task.endTimeDate = null;
          } else {
            this.task.endTimeDate = moment(`${moment().format('YYYY-MM-DD')} ${this.task.endTime}`);
          }
        }

        this.taskTreeLoading = false;
      } else {
        this.task = null;
        this.taskTreeLoading = false;
      }
    });
  }

  @action getByTaskName(taskName) {
    const taskShort = this.taskShorts.find(fi => fi.taskName === taskName);
    let id = 0;
    if (taskShort) {
      id = taskShort.taskID;
    }
    
    return this.getByTaskId(id);
  }

  @action getTaskParentKey(key, tree) {
    let parentKey;

    for (let i = 0; i < tree.length; i++) {
      const node = tree[i];

      if (node.children) {
        if (node.children.some(item => item.key === key)) {
          parentKey = node.key;
        } else if (this.getTaskParentKey(key, node.children)) {
          parentKey = this.getTaskParentKey(key, node.children);
        }
      }
    }

    return parentKey;
  }

  @action initCreate(parentID, parentName, taskLanguages) {
    this.task = {
      'taskID': 0,
      'taskName': '',
      'taskDesc': '',
      'stayPleaseTaskID': 0,
      'parentID': parentID,
      'nextCount': 0,
      'sortID': 0,
      'price': 0,
      'imageUrl': '',
      'total': 0,
      'minimumStock': 0,
      'requestLimit': 0,
      'startTime': null,
      'endTime': null,
      'startTimeDate': null,
      'endTimeDate': null,
      'dailyRequestLimit': 0,
      'menuType': '',
      'isSoon': true,
      'isShown': true,
      'vat': 0,
      'serviceFee': 0,
      'bannerUrl': '',
      'taskLanguages': [],
      'parentName': parentName
    };

    taskLanguages.map(taskLang => {
      this.task.taskLanguages.push({
        'taskLangID': 0,
        'taskID': 0,
        'langID': taskLang.langID,
        'taskLangName': '',
        'type': 0,
        'taskLangDescription': ''
      });

      return taskLang;
    })
  }

  @action create() {
    if (this.task.startTimeDate) {
      this.task.startTime = moment(this.task.startTimeDate).format('HH:mm:00');
    } else {
      this.task.startTime = null;
    }

    if (this.task.endTimeDate) {
      this.task.endTime = moment(this.task.endTimeDate).format('HH:mm:00');
    } else {
      this.task.endTime = null;
    }

    this.task.createdBy = this.cmsUsername;

    return apiCaller.CmsTasks.create(this.task);
  }

  @action update() {
    if (this.task.startTimeDate) {
      this.task.startTime = moment(this.task.startTimeDate).format('HH:mm:00');
    } else {
      this.task.startTime = null;
    }

    if (this.task.endTimeDate) {
      this.task.endTime = moment(this.task.endTimeDate).format('HH:mm:00');
    } else {
      this.task.endTime = null;
    }

    this.task.updatedBy = this.cmsUsername;

    return apiCaller.CmsTasks.update(this.task.taskID, this.task);
  }

  @action delete() {
    return apiCaller.CmsTasks.delete(this.task.taskID, this.cmsUsername);
  }

  @action setexpandedTaskTree(value) {
    this.expandedTaskTree = value;
  }

  @action setselectedTaskTree(value) {
    this.selectedTaskTree = value;
  }

  @action settaskTreeLoading(value) {
    this.taskTreeLoading = value;
  }

  generateList(data) {
    for (let i = 0; i < data.length; i++) {
      const node = data[i];
      const { key } = node;

      this.taskTreeList.push({ key, title: key });

      if (node.children) {
        this.generateList(node.children);
      }
    }
  }

  @action settaskName(value) {
    this.task.taskName = value;
  }

  @action setsortID(value) {
    this.task.sortID = value;
  }

  @action setprice(value) {
    this.task.price = value;
  }

  @action settotal(value) {
    this.task.total = value;
  }

  @action setTaskHasMinimumStock(value) {
    this.task.minimumStock = value ? 1 : 0;

    if (this.task.total === null || this.task.total === '') {
      this.task.total = 0;
    }
  }

  @action setminimumStock(value) {
    this.task.minimumStock = value;
  }

  @action setrequestLimit(value) {
    this.task.requestLimit = value;
  }

  @action setdailyRequestLimit(value) {
    this.task.dailyRequestLimit = value;
  }

  @action setimageUrl(value) {
    this.task.imageUrl = value;
  }

  @action setstartTimeDate(value) {
    if (value) {
      this.task.startTimeDate = value;
    } else {
      this.task.startTimeDate = null;
    }
  }

  @action setendTimeDate(value) {
    if (value) {
      this.task.endTimeDate = value;
    } else {
      this.task.endTimeDate = null;
    }
  }

  @action settaskLangName(langId, value) {
    let lang = this.task.taskLanguages.find(fi => fi.langID === langId);
    if (lang) {
      lang.taskLangName = value;
    }
  }

  @action settaskLangDescription(langId, value) {
    let lang = this.task.taskLanguages.find(fi => fi.langID === langId);
    if (lang) {
      lang.taskLangDescription = value;
    }
  }

  @action setnextCount(value) {
    this.task.nextCount = value ? 1 : 0;
  }
}

export default new CmsTaskStore();